// extracted by mini-css-extract-plugin
module.exports = {"hidden":"Price_hidden__k3auK"};